/**
 * Forgot Password Page
 * Collects an email and triggers a password-reset email.
 */

import { ForgotPasswordForm } from '@/modules/auth';

export default function ForgotPassword() {
  return (
    <div>
      <ForgotPasswordForm />
    </div>
  );
}
